/**
 * Apoyos visuales del banco de palabras (M3). Con la batería PEFF (fase 4) la
 * evaluación ya no arma estímulos desde el cliente —los entrega el API— así que
 * aquí solo queda el emoji de respaldo que usa la práctica (M6) mientras el
 * banco no tenga la fotografía real del ítem.
 */

/** Emojis de apoyo para palabras frecuentes de la batería (placeholder de la
 *  foto real del banco). Fallback genérico si no hay match. */
const EMOJI: Record<string, string> = {
  gato: "🐱",
  plato: "🍽️",
  reina: "👑",
  globo: "🎈",
  flan: "🍮",
  auto: "🚗",
  fresa: "🍓",
  plátano: "🍌",
  platano: "🍌",
  manzana: "🍎",
  tren: "🚂",
  mariposa: "🦋",
  teléfono: "📞",
  telefono: "📞",
  luna: "🌙",
  queso: "🧀",
  sol: "☀️",
  casa: "🏠",
  perro: "🐶",
  pez: "🐟",
  mano: "✋",
};

export function emojiDe(texto: string): string {
  return EMOJI[texto.trim().toLowerCase()] ?? "🖼️";
}
